import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import PropTypes from "prop-types";
import XLSX from 'xlsx';
import {
    Table,
    Breadcrumb,
    Button,
    Icon,
    Dropdown,
    Message
} from "semantic-ui-react";
import _ from "lodash";
import moment from 'moment';
import Dls from "../../lib";
import {
    fetchUploadHistory,
    newFileUploaded,
    sprTaskRemoved,
    sprTaskStarted
} from "../../actions/ecommerce";
import ExcelUpload from "./ExcelUpload";
import {api} from "../../api";


class SprFile extends Component {
    constructor() {
        super();
        this.state = {
            loading: false,
            uploadModal: false
        };
    }

    componentDidMount() {
        this.fetchRecrods();
    }
    
    fetchRecrods = () => {
        const {jwt} = this.props;
    
        this.props.fetchUploadHistory(jwt).catch(err => {
            Dls.apiErrorAlert(err);
        });;
    }

    newFileUploaded = (data) => {
        this.setState({
            uploadModal: false
        });

        this.props.newFileUploaded(data);
    }

    onStartProcessingClick = (record, index) => {
        this.setState({
            loading: true
        }, () => {
            api.ecommerce.startProcessing(this.props.jwt, record.id).then(res => {
                this.props.sprTaskStarted(index, res.data.data)
                this.setState({
                    loading: false
                })
            }).catch(err => {
                Dls.apiErrorAlert(err);
                this.setState({
                    loading: false
                })
            })
        })
    }

    onDeleteTaskClick = (record, index) => {
        this.setState({
            loading: true
        }, () => {
            api.ecommerce.deleteTask(this.props.jwt, record.id).then(res => {
                this.props.sprTaskRemoved(index);
                this.setState({
                    loading: false
                })
            }).catch(err => {
                Dls.apiErrorAlert(err);
                this.setState({
                    loading: false
                })
            })
        });
    }

    onGetReportClick = (record, type) => {
        this.setState({
            loading: true
        }, () => {
            api.ecommerce.getSprUploadReport(this.props.jwt, record.id, type).then(res => {
                const data = [];
                _.each(res.data.data, item => {
                    if (type === 'batch') {
                        data.push({
                            Type: "Products For Existing Period",
                            NewItem: item.current_upload_id === item.initial_upload_id ? "Yes" : "No",
                            SKU: item.excel_sku,
                            Name: item.excel_name,
                            Cost: item.excel_dls_cost,
                            Sell: item.excel_dls_sell,
                            MSRP: item.excel_spr_msrp,
                            SprAvailable: item.spr_id > 0 ? "Yes" : "No",
                            SprStatus: item.latest_spr_status,
                            SprCategory: item.srp_category,
                            SprManufacturer: item.srp_manufacturer,
                            InShopify: item.shopify_id > 0 ? "Yes" : "No",
                            DlsCategory1: item.dls_category_1,
                            DlsCategory2: item.dls_category_2,
                            DlsCategory3: item.dls_category_3
                        });
                    }
                    if (type === 'old') {
                        data.push({
                            Type: "Products From Previous Periods",
                            SKU: item.excel_sku,
                            Name: item.excel_name,
                            Cost: item.excel_cost,
                            Sell: item.excel_sell,
                            MSRP: item.excel_spr_msrp,
                            SprAvailable: item.spr_id > 0 ? "Yes" : "No",
                            SprStatus: item.latest_spr_status,
                            SprCategory: item.srp_category,
                            SprManufacturer: item.srp_manufacturer,
                            InShopify: item.shopify_id > 0 ? "Yes" : "No",
                            DlsCategory1: item.dls_category_1,
                            DlsCategory2: item.dls_category_2,
                            DlsCategory3: item.dls_category_3
                        });
                    }
                })
                const wb = XLSX.utils.book_new();
                const sheetSchema = XLSX.utils.json_to_sheet(data);
                XLSX.utils.book_append_sheet(wb, sheetSchema, 'Report');
                XLSX.writeFile(wb, 'ImportReport.xlsx');
                this.setState({
                    loading: false
                })
            })
        })
    }

    render() {
        const {list} = this.props;
        return (
            <div>
                <div className="row" style={{ marginBottom: "5px" }}>
                    <div className="col-md-8">
                        <Breadcrumb size="huge">
                            <Breadcrumb.Section>
                                SPR Upload List
                            </Breadcrumb.Section>
                        </Breadcrumb>
                    </div>
                    <div className="col-md-4">
                        <div style={{ float: "right" }}>
                            <Button size="mini" color="teal" icon onClick={() => {
                                this.setState({uploadModal: true})
                            }}>
                                <Icon name="file excel outline" />&nbsp;
                                Upload
                            </Button>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12">
                        <Message info>
                            The processing power is 30 records / minute. A file with 15000 rows will take about 8.5 hours. Be patient. <br />
                            Shopify is updated (if needed) at the same time.
                        </Message>
                        <Table compact>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell>
                                        File Uploaded
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>
                                        File Name
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>
                                        Total #
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>
                                        SPR Updated #
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>
                                        Started
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>
                                        Status
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>
                                        Action
                                    </Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>

                            <Table.Body>
                                {_.isArray(list) ? list.map((i, index) => {
                                    return <Table.Row key={i.id}>
                                        <Table.Cell>
                                            {i.created_at}
                                        </Table.Cell>
                                        <Table.Cell>
                                            {i.original_name}
                                        </Table.Cell>
                                        <Table.Cell>
                                            {i.total_rows}
                                        </Table.Cell>
                                        <Table.Cell>
                                            {i.rows_processed}
                                        </Table.Cell>
                                        <Table.Cell>
                                            {i.started_on ? "Yes" : 
                                            <Button size='mini' 
                                                loading={this.state.loading}
                                                disabled={this.state.disabled}
                                                color='teal' onClick={() => {
                                                this.onStartProcessingClick(i, index)
                                            }}>
                                                Start
                                            </Button>}
                                        </Table.Cell>
                                        <Table.Cell>
                                            {i.status}
                                        </Table.Cell>
                                        <Table.Cell>
                                            {i.status === 'Waiting' ? 
                                            <Button size='mini' 
                                                loading={this.state.loading}
                                                disabled={this.state.disabled}
                                                color='red' onClick={() => {
                                                    this.onDeleteTaskClick(i, index)
                                                }}>
                                                Delete
                                            </Button> : null}
                                            {i.status === 'Completed' && index === 0 ?   <Dropdown text='Report'>
                                                <Dropdown.Menu>
                                                    <Dropdown.Item text='Uploaded Item Report' onClick={() => {
                                                        this.onGetReportClick(i, 'batch')
                                                    }}/>
                                                    <Dropdown.Item text='Old Item Report' onClick={() => {
                                                        this.onGetReportClick(i, 'old')
                                                    }}/>
                                                </Dropdown.Menu>
                                            </Dropdown> : null}
                                        </Table.Cell>
                                    </Table.Row>
                                }) : null}
                            </Table.Body>
                        </Table>
                    </div>
                </div>
                {/* <div className="row">
                    <div className="col-md-12" style={{marginTop: '5px'}}>
                        <TablePagination 
                            goToPage={(page) => {this.goToPage(page);}}
                            on_page={list.on_page} 
                            total_records={list.total_count} 
                            per_page={list.per_page} />
                    </div>
                </div> */}

                <ExcelUpload 
                    displayModal={this.state.uploadModal}
                    onCloseModalClick={() => {
                        this.setState({
                            uploadModal: false
                        })
                    }}
                    onUploaded={(data) => {
                        this.newFileUploaded(data)
                    }}
                    sprAlert={true}
                />
            </div>
        );
    }
}

SprFile.propTypes = {
    history: PropTypes.shape({
       push: PropTypes.func.isRequired
    }).isRequired,
    fetchUploadHistory: PropTypes.func.isRequired,
    newFileUploaded: PropTypes.func.isRequired,
    sprTaskRemoved: PropTypes.func.isRequired,
    sprTaskStarted: PropTypes.func.isRequired,
    list: PropTypes.array.isRequired,
    jwt: PropTypes.string.isRequired
};

function mapStateToProps(state) {
    return {
        jwt: state.auth.jwt,
        list: state.ecommerce.uploadHistory
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        fetchUploadHistory,
        newFileUploaded,
        sprTaskRemoved,
        sprTaskStarted
    }, dispatch);
}

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(SprFile)
);



// WEBPACK FOOTER //
// ./src/components/ecommerce/SprFile.js